module.exports = __webpack_public_path__ + "static/media/Sauna.067c47f7.svg";